<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 24 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_554_2939)">
      <path
        d="M3.0801 19.9556H13.0442C14.7453 19.9556 16.1243 18.5834 16.1243 16.8907V7.19106C16.1243 5.4984 14.7453 4.12622 13.0442 4.12622L3.0801 4.12622C1.37899 4.12622 -2.09808e-05 5.4984 -2.09808e-05 7.19106V16.8907C-2.09808e-05 18.5834 1.37899 19.9556 3.0801 19.9556Z"
        fill="url(#paint0_linear_554_2939)"
      />
      <path
        d="M2.63714 15.8589L11.8091 19.7329C13.375 20.3943 15.1832 19.6673 15.8479 18.1092L19.6568 9.18063C20.3214 7.62252 19.5909 5.82328 18.025 5.1619L8.85299 1.28792C7.28711 0.626544 5.47891 1.35348 4.81423 2.91159L1.00538 11.8402C0.340704 13.3983 1.07126 15.1975 2.63714 15.8589Z"
        fill="url(#paint1_linear_554_2939)"
      />
      <path
        d="M3.87833 12.0914L10.924 19.1021C12.1269 20.299 14.0771 20.299 15.28 19.1021L22.1729 12.2434C23.3757 11.0465 23.3757 9.10596 22.1729 7.90907L15.1272 0.898338C13.9243 -0.298559 11.9741 -0.298558 10.7712 0.898338L3.87834 7.75704C2.67547 8.95393 2.67547 10.8945 3.87833 12.0914Z"
        fill="url(#paint2_linear_554_2939)"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_554_2939"
        x1="13.8022"
        y1="12.0409"
        x2="0.185199"
        y2="12.0409"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#00A7FF" />
        <stop offset="1" stop-color="#00A7FF" stop-opacity="0.2" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_554_2939"
        x1="18.4364"
        y1="10.5119"
        x2="1.82498"
        y2="10.5119"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#00A7FF" />
        <stop offset="1" stop-color="#00A7FF" stop-opacity="0.2" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_554_2939"
        x1="22.8357"
        y1="11.3961"
        x2="3.90938"
        y2="8.67685"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#177AF0" />
        <stop offset="0.99" stop-color="#177AF0" stop-opacity="0.5" />
      </linearGradient>
      <clipPath id="clip0_554_2939">
        <rect width="23.0769" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>

<script>
import VueTypes from 'vue-types';
export default {
  name: 'ETLIcon',
  props: {
    height: VueTypes.string.def('16'),
    width: VueTypes.string.def('16'),
  },
};
</script>

<style lang="scss"></style>
